import { __require as m } from "./_arrayEvery.js";
import { __require as o } from "./_baseEvery.js";
import { __require as n } from "./_baseIteratee.js";
import { __require as E } from "./isArray.js";
import { __require as I } from "./_isIterateeCall.js";
var a, u;
function x() {
  if (u) return a;
  u = 1;
  var _ = m(), s = o(), t = n(), q = E(), v = I();
  function y(r, e, i) {
    var f = q(r) ? _ : s;
    return i && v(r, e, i) && (e = void 0), f(r, t(e, 3));
  }
  return a = y, a;
}
export {
  x as __require
};
